import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";
import { ImageBrowserUploadProvider } from '../../providers/image-browser-upload/image-browser-upload';

import { DatePicker } from '@ionic-native/date-picker';


import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';

import { VisitorsRegMorePage } from '../visitors-reg-more/visitors-reg-more';
import { LoginPage } from '../login/login';

declare var cordova: any;

//@IonicPage()
@Component({
  selector: 'page-visitorreport',
  templateUrl: 'visitorreport.html',
})
export class VisitorreportPage {
  private vistor_report : FormGroup;

  fromdt = "";
  todt = "";
  vcode = "";

  report = false;
  isEmpty = true;
  loading: Loading;

  reportData = [];

  validation_messages = {
    'fromdt': [
      { type: 'required', message: '*Please choose from date.' },
      //{ type: 'pattern', message: '*Please enter characters.' }
    ],
    'todt': [
      { type: 'required', message: '*Please choose to date.' },
    ],/*
    'vcode': [
      { type: 'required', message: '*Please enter visitor code.' },
    ],*/
      
  }

  constructor(private formBuilder: FormBuilder,  
    public navCtrl: NavController, 
    private toastCtrl: ToastController, 
    public navParams: NavParams,     
    public http: HttpClient,    
    private imagePicker: ImagePicker,    
    private base64: Base64,
    private camera: Camera, 
    private transfer: Transfer, 
    private file: File, 
    private filePath: FilePath, 
    public actionSheetCtrl: ActionSheetController, 
    public platform: Platform, 
    public loadingCtrl: LoadingController , 
    private _ALERT     : AlertController,
    private _IMAGES 		: ImageBrowserUploadProvider,
    private datePicker: DatePicker,
    public global: GlobalProvider) {
      this.vistor_report = this.formBuilder.group({
        fromdt: ["", Validators.required],
        todt: ["", Validators.required],
        vcode: [null]//["", Validators.required]
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VisitorreportPage');
  }

  showReport(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...',
    });
    this.loading.present();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json'
      })
    };

    this.http.get(this.global.baseUrl+"api/admin/report/visitor?fromDate="+this.fromdt+"&toDate="+this.todt+"&verificationCode="+this.vcode, httpOptions)//requestOpt)
      .subscribe((data:any) => {
        console.log(data['_body']);
        console.log(data);
        console.log(data.error);
          if(data.error == true){
            
            this.loading.dismissAll()
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 3000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            this.report = true;
            this.isEmpty = true;
            //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=false;
            
          }else{
            
            this.loading.dismissAll()
            this.report = true;
            /*let toast = this.toastCtrl.create({
              message: 'Visitor created successfully!.',
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();*/
            //alert(data.events.length);
            if(data.events.length <= 0){
              this.isEmpty = true;
            }else{
              this.isEmpty = false;
              this.reportData = data.events;
            }
            //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=false;
            //this.navCtrl.push(LoginPage);
            
          }
        }, error => {
        console.log(error);
        
        this.loading.dismissAll()
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 3000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        this.report = true;
        this.isEmpty = true;
    });
  }

  goback(){
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/visitorreport/visitorreport.ts